import React, { useRef, useState, useEffect } from 'react'
import { useSwipeable } from 'react-swipeable'
import Button from '@mui/material/Button'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import './slides.scss'

const BasicSlider = ({
  showScrollButtons = true,
  sizeButton = 32,
  ...props
}) => {
  const ref = useRef(null)
  const [scrollPos, setScrollPos] = useState(0)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const [startX, setStartX] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)

  const elements = props.children

  const scroll = (direction = 'left', scrollAmount = 110) => {
    if (ref.current) {
      const newScroll = direction === 'left'
        ? scrollPos + scrollAmount
        : scrollPos - scrollAmount

      setScrollPos(newScroll)
      ref.current.scrollLeft = newScroll
    }
  }

  useEffect(() => {
    if (ref.current) {
      const widthSlider = ref.current.scrollWidth
      const widthContent = ref.current.clientWidth
      if (widthContent < widthSlider) {
        setIsOverflowing(true)
      }
    }
  }, [ref.current])

  const handlers = useSwipeable({
    onSwipedLeft: () => scroll('right'),
    onSwipedRight: () => scroll('left'),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  })

  const ScrollButton = ({ type = 'right' }) => {
    const gradientDir = type
    const gradient = `linear-gradient(to ${gradientDir}, rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 1.0))`
    const scrollDir = type === 'left' ? 'right' : 'left'

    const left = type === 'left' ? '0' : 'auto'
    const right = type === 'right' ? '0' : 'auto'
    const textAlign = type === 'left' ? 'left' : 'right'
    const wrapperStyle = {
      position: 'absolute',
      background: gradient,
      top: '-2px',
      left: left,
      right: right,
      height: '100%',
      width: '60px',
      textAlign: textAlign,
      zIndex: '100',
    }

    const buttonStyle = {
      backgroundColor: 'rgba(255, 255, 255, 1.0)',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      borderRadius: 28,
      minWidth: sizeButton,
      width: sizeButton,
      height: sizeButton,
    }

    const iconStyle = { color: 'rgba(0, 0, 0, 0.6)', marginLeft: 1.6 }
    const Icon = type === 'left'
      ? <KeyboardArrowLeftIcon sx={iconStyle} />
      : <KeyboardArrowRightIcon sx={iconStyle} />
    return (
      <div
        className={`scroll-buttons left`}
        style={wrapperStyle}>
        <Button
          variant="outlined"
          onClick={() => scroll(scrollDir)}
          size={'medium'}
          sx={buttonStyle}
          startIcon={Icon}
        />
      </div>
    )
  }

  return (
    <div
      id={`slider-basic`}
      className={`slider-basic`}
      ref={ref}
      {...handlers}
      >
      <div className={`wrapper scrollbar-hide`} id={'slider-basic-wrapper'}>
        <span className={`slider-content`}>
          {elements}
        </span>
      </div>

      {showScrollButtons && scrollPos > 0
        ? <ScrollButton type={'left'} />
        : null
      }
      {isOverflowing && showScrollButtons
        ? <ScrollButton type={'right'} />
        : null
      }
    </div>
  )
}

BasicSlider.defaultProps = {
  center: false,
  initialSlide: 0,
}

export default BasicSlider